<template>
    <div class="card">
        <div class="card-body">
            <div class="d-flex align-items-center mb-4">
                <div class="font-weight-bold text-primary mr-3">Тариф {{ company.fare.name }}</div>
                <small class="text-primary">
                    <span v-if="company.fare_next && company.fare_next.id !== company.fare.id">
                        Переход на тариф <b>{{ company.fare_next.name }}</b> c {{ company.fare_next.valid_from | date('DD.MM') }}
                    </span>
                    <span v-else>бессрочный</span>
                </small>
            </div>

            <div class="d-flex flex-column flex-lg-row">
                <div class="mb-4 mb-lg-0 flex-fill" v-html="company.fare.description" />

                <div class="ml-lg-5">
                    <button class="btn btn-lg-192 btn-outline-primary" type="button" @click="modal = true">Сменить тариф</button>
                </div>
            </div>

            <TheModal v-if="modal" class="sm nofh" @close="closeModal">
                <template slot="head">Смена тарифа</template>

                <div class="fare-list">
                    <div v-for="fare in fares" :key="fare.id" class="fare-list-item d-flex justify-content-between">
                        <div class="fare-description">
                            <div class="d-flex align-items-center mb-3">
                                <div class="custom-control custom-radio">
                                    <input :id="`fare_${fare.id}`" v-model="fareId" type="radio" class="custom-control-input" name="fare" :value="fare.id">
                                    <label class="h5 custom-control-label text-primary" :for="`fare_${fare.id}`">{{ fare.name }}</label>
                                </div>
                                <span v-if="fare.id === company.fare.id" class="badge badge-primary ml-3">Текущий</span>
                            </div>

                            <p v-html="fare.description" />
                        </div>

                        <div class="text-nowrap ml-3">
                            <p class="h5 text-primary text-right mb-3">от {{ fare | fareCost }} {{ company.balance_currency | currencySymbol }}/мес</p>

                            <small v-if="fare.rate && fare.rate.monthly_modem" class="d-block text-muted text-right">
                                {{ fare.rate.monthly_modem }} {{ company.balance_currency | currencySymbol }} за 1 модем
                            </small>

                            <small v-if="fare.rate && fare.rate.monthly_sim" class="d-block text-muted text-right">
                                {{ fare.rate.monthly_sim }} {{ company.balance_currency | currencySymbol }} за 1 сим-карту
                            </small>
                        </div>
                    </div>
                </div>

                <div v-if="selectedFare" class="d-flex flex-row mt-3 mx-2">
                    <div class="align-self-center flex-grow-1">
                        <div class="font-weight-bold">{{ selectedFare.name }}</div>
                        <div class="font-weight-bold text-primary">
                            от {{ selectedFare | fareCost }} {{ company.balance_currency | currencySymbol }}/мес
                        </div>
                    </div>

                    <button :disabled="pending" class="btn btn-lg btn-primary ml-3" type="button" @click="apply">Сменить</button>
                </div>
            </TheModal>
        </div>
    </div>
</template>

<script>
import TheModal from '@/components/TheModal'
import find from 'lodash/find'

export default {
    components: {
        TheModal
    },

    filters: {
        fareCost(fare) {
            return fare.rate ? (fare.rate.monthly_sim || 0) + (fare.rate.monthly_modem || 0) : 0
        }
    },

    props: {
        pending: {
            type: Boolean,
            default: false
        },

        company: {
            type: Object,
            default: _ => ({})
        },

        fares: {
            type: Array,
            default: _ => []
        }
    },

    data() {
        return {
            modal: false,
            fareId: null
        }
    },

    computed: {
        selectedFare() {
            return this.fareId ? find(this.fares, { id: this.fareId }) : null
        }
    },

    methods: {
        apply() {
            this.$emit('apply', this.fareId)
            this.closeModal()
        },

        closeModal() {
            this.modal = false
            this.fareId = null
        }
    }
}
</script>
